import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import {
    loadTrackingScriptAsync,
    setTrackingIsReadyState,
} from '../../actions/tracking/tracking.actions'
import { init } from '../../actions/core/init.actions'
import config from '../../../config'
import isTrackingEnabledSelector from '../../selectors/feature-scope/isTrackingEnabledSelector'

const loadTrackingScriptMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    const isTrackingEnabled = isTrackingEnabledSelector(store.getState())

    if (isActionOf(init, action)) {
        if (isTrackingEnabled) {
            store.dispatch(loadTrackingScriptAsync.request(undefined, undefined))
        } else {
            // If tracking is disabled, immediately set tracking as ready so it doesn't block app rendering
            store.dispatch(setTrackingIsReadyState(true))
        }
    }

    if (isActionOf(loadTrackingScriptAsync.request, action)) {
        if (config.TRACKING_URL === undefined) {
            store.dispatch(loadTrackingScriptAsync.failure(undefined, undefined))
            console.error('No Tracking URL provided. Tracking is disabled')
            return
        }

        const trackingScript = document.createElement('script')

        trackingScript.onload = () => {
            store.dispatch(loadTrackingScriptAsync.success(undefined, undefined))
        }

        trackingScript.onerror = () => {
            store.dispatch(loadTrackingScriptAsync.failure(undefined, undefined))
        }

        trackingScript.src = config.TRACKING_URL

        document.head.append(trackingScript)
    }

    if (
        isActionOf(loadTrackingScriptAsync.success, action)
        || isActionOf(loadTrackingScriptAsync.failure, action)
    ) {
        store.dispatch(setTrackingIsReadyState(true))
    }
}

export default loadTrackingScriptMiddleware
